<template>
	<div class="answer-cnt" role="radiogroup">
		<ja-card
			v-for="answer in answers"
			:key="answer.lifestyle_Question_Option_ID"
			:selected="selectedAnswer == answer.lifestyle_Question_Option_ID"
			:aria-checked="
				(selectedAnswer == answer.lifestyle_Question_Option_ID).toString()
			"
			role="radio"
			@click.native="selectAnswer(answer)"
		>
			{{ answer.text }}
		</ja-card>
	</div>
</template>
<script>
import Card from '@/components/ui/Card';
export default {
	components: {
		jaCard: Card
	},
	props: {
		answers: {
			type: Array,
			default: () => {}
		},
		selectedAnswer: {
			type: String,
			default: ''
		}
	},
	methods: {
		selectAnswer(answer) {
			this.$emit('answerSelected', {
				answer: answer.lifestyle_Question_Option_ID,
				text: answer.text
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.answer-cnt {
	display: flex;
	flex-direction: column;
	width: 100%;
}
</style>
